import React from 'react'

const NotFound = () => (
  <div style={{ textAlign: 'center' }}>
    <h1>Oh where oh where did my page go?</h1>
    <img
      alt="404 not found"
      src="https://media.giphy.com/media/42D3juTNiHREk/giphy.gif"
    />
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound.js